<template>
  <div class="matchingImage">
    <figure>
      <img :src="avatar" alt="미국 국기" @error="setAvatar" />
    </figure>
    <div class="matchingImage">
      <div>
        <h6 class="matchingImageLabel">
          {{ item.company }}
        </h6>
        <h5 style="color: #294A7A" class="matchingImageSubLabel">
          {{ item.name }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import { ROLE } from "@/data/role";
export default {
  name: "CorpAdminDirectMatching",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      avatar: this.item.avatar,
    };
  },
  methods: {
    setAvatar() {
      this.avatar = this.getDefaultAvatar(ROLE.CORP);
    },
  },
  watch: {
    "item.avatar": {
      handler(val) {
        this.avatar = this.getAvatarLink(val, this.getDefaultAvatar(ROLE.CORP));
      },
      immediate: true,
    },
  },
};
</script>
